// extracted by mini-css-extract-plugin
export var ArrowIcon = "ArrowIcon-module--ArrowIcon--xHcjJ";
export var aniSpin = "ArrowIcon-module--ani-spin--L32Zl";
export var bar = "ArrowIcon-module--bar--lgED6";
export var endBottom = "ArrowIcon-module--endBottom--dmmMo";
export var endTop = "ArrowIcon-module--endTop--weekz";